var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.openDia,"close-on-click-modal":false,"width":"300px"},on:{"close":_vm.closeMeeting}},[(_vm.imAccount && _vm.imToken)?_c('chat-meeting',{attrs:{"imAccount":_vm.imAccount,"imToken":_vm.imToken},on:{"open":function($event){_vm.openMeeting = true},"close":function($event){_vm.openMeeting = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }